import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Pagination, usePagination } from "@/components/Pagination";
import ConfirmDelete from "@/components/ConfirmDelete";

export default function Clients() {
  const { isReadOnly } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "" });
  const [pageItems, ctrl] = usePagination(items, 10);
  const [confirmDel, setConfirmDel] = useState(null);
  const load = async () => setItems((await api.get("/clients")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/clients", form);
      toast.success("Client ditambahkan");
      setForm({ name: "", company: "", email: "", phone: "" });
      load();
    } catch (err) { toast.error(formatApiError(err?.response?.data?.detail)); }
  };
  const remove = async (id) => { await api.delete(`/clients/${id}`); load(); };
  const doConfirmDel = async () => { if (!confirmDel) return; await remove(confirmDel.id); setConfirmDel(null); };

  return (
    <div className="space-y-8" data-testid="clients-page">
      <div>
        <div className="label-mini">Client</div>
        <h1 className="mt-1 font-heading text-4xl font-black tracking-tight">Direktori Client</h1>
      </div>
      {!isReadOnly && (
      <form onSubmit={submit} className="card-tech p-6 grid grid-cols-1 md:grid-cols-4 gap-4">
        <div><Label className="label-mini">Nama</Label>
          <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="client-name-input" /></div>
        <div><Label className="label-mini">Perusahaan</Label>
          <Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} data-testid="client-company-input" /></div>
        <div><Label className="label-mini">Email</Label>
          <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="client-email-input" /></div>
        <div><Label className="label-mini">Telp</Label>
          <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="client-phone-input" /></div>
        <div className="md:col-span-4">
          <Button type="submit" className="rounded-sm" data-testid="add-client-button"><Plus className="h-4 w-4 mr-2" />Tambah</Button>
        </div>
      </form>
      )}

      <div className="card-tech p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-accent text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left px-6 py-3">Nama</th>
              <th className="text-left px-6 py-3">Perusahaan</th>
              <th className="text-left px-6 py-3">Email</th>
              <th className="text-left px-6 py-3">Telp</th>
              <th className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="px-6 py-10 text-center text-muted-foreground">Belum ada client.</td></tr>}
            {pageItems.map((it) => (
              <tr key={it.id} className="border-t border-border" data-testid={`client-row-${it.id}`}>
                <td className="px-6 py-3 font-medium">{it.name}</td>
                <td className="px-6 py-3 text-muted-foreground">{it.company}</td>
                <td className="px-6 py-3 mono text-xs">{it.email}</td>
                <td className="px-6 py-3 mono text-xs">{it.phone}</td>
                <td className="px-6 py-3 text-right">
                  {!isReadOnly && (
                    <Button size="sm" variant="ghost" onClick={() => setConfirmDel(it)} data-testid={`delete-client-${it.id}`}><Trash2 className="h-4 w-4" /></Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination ctrl={ctrl} testidPrefix="clients-pg" />
      </div>
      <ConfirmDelete
        open={!!confirmDel}
        onOpenChange={(v) => !v && setConfirmDel(null)}
        onConfirm={doConfirmDel}
        entityLabel={confirmDel?.name}
        testIdPrefix="confirm-delete-client"
      />
    </div>
  );
}
